import React, { Component } from "react";

const ChangeResultDetail = ({ contracts, tariff, changeType }) => {
  let changes = contracts;
  if (tariff) {
    changes = changes.concat([
      {
        contractName: "Tariff " + tariff.planCode,
        change: tariff.change,
        startDate: tariff.startDate,
        status: tariff.status,
        reason: tariff.reason,
      },
    ]);
  }

  return (
    <ul className="applied-change">
      {changes.map(c => {
        let description = "";
        if (changeType === "unknown") {
          description = "";
        }
        switch (c.change) {
          case "enable":
            description = "Adding";
            break;
          case "disable":
            description = "Removing";
            break;
          case "modify":
            description = "Modifying";
            break;
          default:
            description = "No change to";
            c.status = null; // Don't show as a successful change
        }
        if (changeType === "unknown") {
          description = "";
        }
        switch (c.status) {
          case "SUCCESSFUL":
            return (
              <li key={c.contractName} className="success">
                {description} {c.contractName} - {c.startDate}
                {c.change ? " (Succeeded)" : ""}
              </li>
            );
          case "UNSUCCESSFUL":
            return (
              <li key={c.contractName} className="fail">
                {description} {c.contractName} - {c.startDate} (Failed - {c.reason})
              </li>
            );
          case null:
            return (
              <li key={c.contractName} className="nochange">
                {description} {c.contractName} - {c.startDate}
              </li>
            );
          default:
            return (
              <li key={c.contractName} className="nochange">
                {description} {c.contractName} - {c.startDate}
              </li>
            );
        }
      })}
    </ul>
  );
};

class CustomerContractsAppliedChangesDetailsTable extends Component {
  getRowHeight = idx => {
    return Math.max(60, this.props.changesList[idx].contracts.length * 19);
  };

  render() {
    let changesList = this.props.changesList;
    changesList.sort((a, b) => a.nmi - b.nmi);

    return (
      <table>
        <thead>
          <tr>
            <th>NMI</th>
            <th>Changes</th>
          </tr>
        </thead>
        <tbody>
          {changesList.map(change => {
            return (
              <tr>
                <td>{change.nmi}</td>
                <td>
                  {
                    <ChangeResultDetail
                      contracts={change.contracts}
                      tariff={change.tariff}
                      changeType={this.props.changeType}
                    />
                  }
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
}

export default CustomerContractsAppliedChangesDetailsTable;
